import styles from "./legend-icon-button.module.scss";
import { useTranslation } from "react-i18next";
import Svg from "components/svg/svg";
import { Tooltip, IconButton } from "@mui/material";

interface Props {
    tableData: any;
    activeLegend: any;
    analysedLegends: any;
    handleLegendClick: (index: number, layerId: string) => void
}

function LegendIconButton({
    tableData,
    activeLegend,
    analysedLegends,
    handleLegendClick
}: Readonly<Props>) {
    const [t] = useTranslation();

    let arr = [];
    if (tableData.length > 0) {
        arr = tableData.map((item: any) => item[0]?.layerId);
    } else {
        arr = analysedLegends!.map((item: any) => (item.id || item.layerId));
    }
    return (<>{
        arr.map((tableDataItem: any, index: number) => {
            return (
                <Tooltip placement="top" title={t("layerId." + tableDataItem)} key={tableDataItem}>
                    <IconButton
                        onClick={() => {
                            handleLegendClick(index, tableDataItem);
                        }}
                        className={`${activeLegend === index ? styles.activeLegend : ""}`}
                    >
                        {Svg({ icon: tableDataItem })()}
                    </IconButton>
                </Tooltip>
            );
        })
    }</>)
}

export default LegendIconButton